var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-history"
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v("Informatie")]), _c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('b-tbody', [_c('b-tr', [_c('b-th', [_vm._v("Ordernummer")]), _c('b-td', [_vm._v(_vm._s(_vm.salesOrder.identifier))])], 1), _c('b-tr', [_c('b-th', [_vm._v("Geplaatst op")]), _c('b-td', [_vm._v(_vm._s(_vm.datetime(_vm.salesOrder.created_at)))])], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" Geschiedenis ")]), _vm.loadingOrderHistory ? [_c('span', {
    staticClass: "icon mr-2"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Bezig met laden van de ordergeschiedenis… ")])] : _vm.orderHistoryAvailable ? [_c('b-table', {
    attrs: {
      "selectable": false,
      "items": _vm.orderHistoryProcessed,
      "fields": this.displayPrefs.orderHistory.fields,
      "select-mode": "single",
      "stacked": "sm"
    }
  })] : [_c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Er is geen geschiedenis beschikbaar.")])]], 2)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }